// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSetReviewReactionWebRequest,
  TSetReviewReactionWebModel,
  IMappers,
  TSetReviewReactionWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISetReviewReactionWebResponse } from '../../entities/set_review_reaction/SetReviewReactionWebResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSetReviewReactionWebModel(parameters: TSetReviewReactionWebRequest): TSetReviewReactionWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-reviews',
    pathApi: '/v1/set-review-reaction-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISetReviewReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSetReviewReactionWebRequest;
}

export async function fetchSetReviewReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetReviewReactionWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSetReviewReactionWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSetReviewReactionWebModel(parameters),
    config,
  )) as FetchResponse<TSetReviewReactionWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetReviewReactionWebResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSetReviewReactionWebResponse>;
}
